import React, { useState, useEffect } from 'react';
import api from '../services/api';

interface Staff {
  id: number;
  name: string;
}

interface Survey {
  id?: number;
  title: string;
  description: string;
  type: string;
  is_active: boolean;
  responsible?: number;
}

interface SurveyFormProps {
  onSuccess: () => void;
  onCancel: () => void;
  surveyToEdit?: Survey | null;
}

const SurveyForm: React.FC<SurveyFormProps> = ({ onSuccess, onCancel, surveyToEdit }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('Communication');
  const [isActive, setIsActive] = useState(true);
  const [responsible, setResponsible] = useState<number | ''>('');
  const [allStaff, setAllStaff] = useState<Staff[]>([]);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await api.get(`staff/`);
        setAllStaff(response.data);
      } catch (error) {
        console.error('Failed to fetch staff', error);
      }
    };
    fetchStaff();
  }, []);

  useEffect(() => {
    if (surveyToEdit) {
      setTitle(surveyToEdit.title);
      setDescription(surveyToEdit.description);
      setType(surveyToEdit.type);
      setIsActive(surveyToEdit.is_active);
      setResponsible(surveyToEdit.responsible || '');
    } else {
      setTitle('');
      setDescription('');
      setType('Communication');
      setIsActive(true);
      setResponsible('');
    }
  }, [surveyToEdit]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const surveyData = { 
      title, 
      description, 
      type, 
      is_active: isActive,
      responsible: responsible || null
    };

    try {
      if (surveyToEdit) {
        await api.patch(`surveys/${surveyToEdit.id}/`, surveyData);
      } else {
        await api.post(`surveys/`, surveyData);
      }
      onSuccess();
    } catch (error) {
      console.error('Failed to save survey', error);
      alert('Erro ao salvar pesquisa.');
    }
  };

  return (
    <div className="card">
      <h3>{surveyToEdit ? 'Editar Pesquisa' : 'Nova Pesquisa'}</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Título</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Tipo</label>
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="Communication">Comunicação</option>
            <option value="Climate">Clima Escolar</option>
          </select>
        </div>
        <div className="form-group">
          <label>Status</label>
          <select value={isActive ? 'true' : 'false'} onChange={(e) => setIsActive(e.target.value === 'true')}>
            <option value="true">Ativa</option>
            <option value="false">Encerrada</option>
          </select>
        </div>
        <div className="form-group">
          <label>Responsável</label>
          <select value={responsible} onChange={(e) => setResponsible(Number(e.target.value))} required>
            <option value="">Selecione um responsável...</option>
            {allStaff.map(staff => (
              <option key={staff.id} value={staff.id}>{staff.name}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Descrição</label>
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button type="button" onClick={onCancel} className="btn btn-secondary">Cancelar</button>
          <button type="submit" className="btn">Salvar</button>
        </div>
      </form>
    </div>
  );
};

export default SurveyForm;
